const $ = require('jquery');
const css = require('./login-form.css');
const { Text } = require('account-ui');
const { inputText, blurText } = require('../../../../signals/form');

class LoginForm {
    constructor () {
        this.template = require('./template.hbs');
    }

    render () {
        return this.$context.getWatcherData().then((data) => Object.assign({}, data, { css }));
    }

    bind () {
        this.focusFirstField();
    }

    focusFirstField () {
        let focused = $(':focus');
        let email = $('input[id="text-email-field"]');

        if (!focused.length || focused[0].tagName != 'INPUT') {
            email.focus();
        }
    }
}

module.exports = {
    constructor: LoginForm,
    children: [
        {
            name: 'text-email',
            component: Text,
            props: {
                placeholder: 'Email',
                signals: { inputText, blurText }
            },
            watcher: {
                value: ['login', 'form', 'username']
            }
        },
        {
            name: 'text-password',
            component: Text,
            props: {
                placeholder: 'Пароль',
                type: 'password',
                signals: { inputText, blurText }
            },
            watcher: {
                value: ['login', 'form', 'password']
            }
        }
    ]
};



// WEBPACK FOOTER //
// ./components/auth/login/form/index.js